import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=20d30af2&scoped=true&"
import script from "./EventForm.vue?vue&type=script&lang=js&"
export * from "./EventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d30af2",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BButton} from 'bootstrap-vue'
    installComponents(component, {BAlert, BButton})
    

export default component.exports